export default {
  data: () => ({
    unitsValues: ['CFS', 'GPM', 'MGD', 'IMGD', 'AFD', 'LPS', 'LPM', 'MLD', 'CMH', 'CMD'],
    headlossValues: ['H-W', 'D-W', 'C-M'],
    unbalancedValues: ['CONTINUE', 'STOP'],
    qualityValues: ['NONE', 'CHEMICAL', 'AGE', 'TRACE'],
    massUnitsValues: ['mg/L', 'ug/L'],
    orderWallValues: ['0', '1'],
    statisticValues: ['NONE', 'AVERAGE', 'MINIMUM', 'MAXIMUM', 'RANGE'],
  }),
};
